import { FileUploader, FileUploaderOptions, FileLikeObject, FileItem } from "ng2-file-upload";
import { Trascodifica, DocumentoRichiestaMutuo, RichiestaMutuoRichiedente } from ".";
import { AlertService } from "app/services/alert.service";

export class DocumentiRichiestaMutuoUploader {

    uploader: FileUploader;
    tipologia: Trascodifica;
    richiedente: RichiestaMutuoRichiedente;
    documenti: Array<DocumentoRichiestaMutuo>;

    constructor(allowedFileType: string[], realAllowedFileType: string[], maxFileSize: number, queueLimit: number, tipologia: Trascodifica, 
            notification: AlertService, richiedente: RichiestaMutuoRichiedente, documenti: Array<DocumentoRichiestaMutuo>) {
        this.documenti = documenti;
        this.richiedente = richiedente;

        this.uploader = new FileUploader({});
        let options: FileUploaderOptions = this.uploader.options;
        options.allowedFileType = allowedFileType;
        options.maxFileSize = maxFileSize;
        options.queueLimit = queueLimit;
        this.uploader.setOptions(options);
        
        this.uploader.onAfterAddingFile = (item: FileItem) => {
            if(!realAllowedFileType.includes( item.file.name.split('.')[item.file.name.split('.').length-1].toLocaleLowerCase()) )
            {
                notification.error('Non è possibile caricare un file del tipo ' + item.file.name.split('.')[item.file.name.split('.').length-1] +
                                        '. I tipi permessi sono ' + realAllowedFileType + '.', true, 10000);
                item.remove();
            }
        }

        this.uploader.onWhenAddingFileFailed = (item: FileLikeObject, filter: any, options: FileUploaderOptions) => {
            let errors: string = '';
            if(!realAllowedFileType.includes( item.name.split('.')[item.name.split('.').length-1].toLocaleLowerCase()) )
            {
                errors += 'Non è possibile caricare un file del tipo ' + item.name.split('.')[item.name.split('.').length-1] +
                                    '. I tipi permessi sono ' + realAllowedFileType + '.';
            }
            if(item.size > options.maxFileSize)
            {
                errors += ' Non è possibile caricare un file con peso maggiore di ' + (options.maxFileSize / 1024 / 1024) + ' MB.';
            }
            if(errors != '')
            {
                notification.error(errors, true, 10000);
            }
        }

        this.tipologia = tipologia;
    }
}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/documenti-richiesta-mutuo-uploader.ts